import {clsx} from 'clsx'
import {forwardRef} from 'react'
import type {SpaceProps, TypographyProps} from 'styled-system'

import styles from './borderless-text-input.module.css'

type StyledBorderLessTextInputProps = React.InputHTMLAttributes<HTMLInputElement> & TypographyProps & SpaceProps

export const BorderlessTextInput = forwardRef<HTMLInputElement, StyledBorderLessTextInputProps>(
  function BorderlessTextInput(
    {
      className,
      // Styled-system props that should not be passed to DOM
      fontSize,
      lineHeight,
      fontWeight,
      fontFamily,
      textAlign,
      pl,
      pr,
      pt,
      pb,
      px,
      py,
      p,
      ml,
      mr,
      mt,
      mb,
      mx,
      my,
      m,
      ...props
    },
    forwardedRef,
  ) {
    // A solution to make this component work without the interference of the wrapper of Primer's `TextInput`
    return <input {...props} ref={forwardedRef} className={clsx(styles.Box, className)} />
  },
)

BorderlessTextInput.displayName = 'BorderlessTextInput'
